<template>
  <div id="wrapper">
    <TextHeader
      header-bg="radial-gradient(circle farthest-corner at 13% 102%, #3b464e 21%, #080806)"
    />
    <div class="w-container">
      <SectionHeader :text="$t('navbar.management')" :show-back-text="true" />
      <div v-for="item in data" :key="item.name" class="manager-wrapper">
        <div
          class="manager-image"
          :style="{ backgroundImage: 'url(' + item.thumbnail + ')' }"
        ></div>
        <div class="manager-details">
          <h3 class="manager-name">{{ item.name }}</h3>
          <h4 class="manager-position">{{ item.position }}</h4>
          <div class="separator"></div>
          <div class="manager-description" v-html="item.description"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from "./SectionHeader";
import TextHeader from "./TextHeader";

export default {
  name: "Management",
  data() {
    return {
      data: null
    };
  },
  components: { TextHeader, SectionHeader },
  mounted() {
    this.$http.get("member/").then(response => (this.data = response.data));
  }
};
</script>

<style scoped>
#wrapper {
  background-color: #f0f0f0;
}

.manager-wrapper {
  display: flex;
  flex-direction: row;
  padding: 38px 0;
  border-top: 1px solid #cbcbcb;
}

.manager-name {
  font-size: 2.5em;
}

.manager-image {
  width: 35%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}

.manager-details {
  width: 65%;
  padding-left: 65px;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
}

.manager-position {
  width: 60%;
  color: #777;
  font-weight: 300;
  font-size: 1.6em;
}

.separator {
  height: 6px;
  background-color: black;
  width: 25%;
  margin-top: 30px;
  margin-bottom: 15px;
}

.manager-description {
  color: #807d7d;
  font-size: 1em;
  line-height: 1.5em;
}

@media (max-width: 767px) {
  .manager-image {
    margin: 0 auto;
    height: calc(100vw - 60px);
    width: calc(100% - 30px);
    background-position: 0 20%;
  }

  .manager-wrapper {
    flex-direction: column;
  }

  .manager-details {
    width: 100%;
    padding: 0 15px;
    min-height: inherit;
  }

  .manager-position {
    width: 100%;
  }
}
</style>
